module.exports = __webpack_public_path__ + "assets/img/thumb-CMTP-Website.1104dc0e.webp";